import { FC } from "react";
import { Navigate } from "react-router-dom";
import { usePaths } from "routes";

export const AdminPage: FC = () => {
  const paths = usePaths();

  return <Navigate to={paths.adminArtworks()} replace />;
};
